@use '../../scss/utility';

:host {
  --size: #{utility.wb-pixel-to-rem(48px)};
  --font-size: #{utility.wb-pixel-to-rem(18px)};
  --color: var(--wb-white);
  --background-color: var(--wb-grey-30);
  --border-radius: 50%;
  --focus-color: var(--wb-blue-45);

  position: relative;
  display: flex;
  width: var(--size);
  height: var(--size);
  justify-content: center;
  align-items: center;
  border-radius: var(--border-radius);
  color: var(--color);
  background-color: var(--background-color);
  cursor: pointer;
}

.icon,
::slotted(.wb-icon) {
  fill: var(--color);
}

.initials {
  font-size: var(--font-size);
}

::slotted(img) {
  border-radius: var(--border-radius);
  width: var(--size);
  height: var(--size);
  position: absolute; // places the image above the other elements within the avatar
}

:host(:hover),
:host(.highlighted) {
  --background-color: var(--wb-grey-45);

  .overlay {
    position: absolute;
    width: var(--size);
    height: var(--size);
    border-radius: var(--border-radius);
    background-color: var(--wb-grey-45);
    opacity: 0.5;
    z-index: 1;
  }
}

:host(:focus-visible) {
  outline-offset: utility.wb-pixel-to-rem(1px);
  outline: utility.wb-pixel-to-rem(1px) solid var(--focus-color);
  border-radius: var(--border-radius);
}

:host([size='xxs']) {
  --size: #{utility.wb-pixel-to-rem(24px)};
  --font-size: #{utility.wb-pixel-to-rem(10px)};

  .icon,
  ::slotted(.wb-icon) {
    --size: #{utility.wb-pixel-to-rem(12px)};
  }
}

:host([size='xs']) {
  --size: #{utility.wb-pixel-to-rem(32px)};
  --font-size: #{utility.wb-pixel-to-rem(12px)};

  .icon,
  ::slotted(.wb-icon) {
    --size: #{utility.wb-pixel-to-rem(16px)};
  }
}

:host([size='s']) {
  --size: #{utility.wb-pixel-to-rem(40px)};
  --font-size: #{utility.wb-pixel-to-rem(12px)};

  .icon,
  ::slotted(.wb-icon) {
    --size: #{utility.wb-pixel-to-rem(16px)};
  }
}

:host([size='l']) {
  --size: #{utility.wb-pixel-to-rem(56px)};
}

:host([size='xl']) {
  --size: #{utility.wb-pixel-to-rem(72px)};

  .icon,
  ::slotted(.wb-icon) {
    --size: #{utility.wb-pixel-to-rem(32px)};
  }
}

:host([size='xxl']) {
  --size: #{utility.wb-pixel-to-rem(120px)};
  --font-size: #{utility.wb-pixel-to-rem(24px)};

  .icon,
  ::slotted(.wb-icon) {
    --size: #{utility.wb-pixel-to-rem(32px)};
  }
}
